<template>
    <div class="my_model">
        <div class="model_container">
            <el-table
                :data="userProjectList"
                :header-cell-style="tableHeaderStyle"
                :cell-style="setCellStyle"
                :row-class-name="tableRowClassName"
                style="width: 100%">
                <el-table-column prop="fileName" label="文件名称" >
                    <template slot-scope="scope">
                        <span style="color: #606060; font-size: 1.09rem;">{{scope.row.fileName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="thumbnail" label="缩略图" >
                    <template slot-scope="scope">
                        <img :src="scope.row.thumbnail" title="缩略图" style="width: 3.63rem;; height: 3.75rem; cursor: pointer;">
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="创建时间" >
                    <template slot-scope="scope">
                        <span style="color: #999999; font-size: 0.85rem;">{{scope.row.createdAt}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="updatedAt" label="更新时间" >
                    <template slot-scope="scope">
                        <span style="color: #999999; font-size: 0.85rem;">{{scope.row.updatedAt}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="operate" label="操作" >
                    <template slot-scope="scope">
                        <div class="operate_inner">
                            <div class="img_container">
                                <img src= "../../../assets/image/资源 35.png" title="转发"
                                 @click="shareModel(scope.row.id, scope.row.modelName, scope.row.modelType)"
                                 style="width: 1rem; height: 1rem; cursor: pointer; margin-right: 7%;">
                            </div>
                            <i class="el-icon-delete-solid"
                             @click="deleteModel(scope.row.id)" title="删除"
                             style="font-size: 24px; padding-left: 0.5rem; border-left: 1px solid #C9C9C9"></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="model_page">
                <el-pagination
                    background
                    :current-page="currentElPage"
                    :total="total"
                    :page-size="size"
                    @size-change="handleChangeSize"
                    @current-change="currentChange"
                    :hide-on-single-page="value"
                    layout="prev, pager, next"
                >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import ModelShowList from '../../../components/modelShowList/index.vue'
import { getMyModels } from '../../../api/api'
import { getUserProject, deleteUserFile, getUserFile } from '../../../util/index'
export default {
    data() {
        return {
            modelList:[
                {
                    order:1,
                    name:'文件1',
                    url:require('../../../assets/image/资源 230.png'),
                    time:'2024年2月29日 15:20:20',
                    icon:require('../../../assets/image/资源 11.png'),
                    operate:'删除'
                },
                {
                    order:2,
                    name:'文件2',
                    url:require('../../../assets/image/资源 230.png'),
                    time:'2024年2月29日 15:20:20',
                    icon:require('../../../assets/image/资源 11.png'),
                    operate:'删除'
                },
                {
                    order:3,
                    name:'文件3',
                    url:require('../../../assets/image/资源 230.png'),
                    time:'2024年2月29日 15:20:20',
                    icon:require('../../../assets/image/资源 11.png'),
                    operate:'删除'
                },
            ],
            userProjectList:[],
            userProjectLists:[],
            total: 0,
            totalProjects:0,
            totalPages: 0,
            value: false,  //隐藏分页
            currentElPage: 1,  //当前页
            size: 10
        }
    },
    methods:{
        // 表行样式
        tableRowClassName(row, rowIndex){
            if ((row.rowIndex+1) % 2 === 1){
                return 'deep'
            }else if((row.rowIndex+1) % 2 === 0){
                return 'shallow'
            }
        },
        // 表头样式
        tableHeaderStyle({row, column, rowIndex, columnIndex}){
            let extra = {}
            if (rowIndex === 0 && columnIndex === 0) {
                extra = {
                    'background-color':'red',
                    'border-radius':'0.56rem 0 0 0.56rem'
                }
            } else if(rowIndex === 0 && columnIndex === 4){
                extra = {
                    'background-color':'red',
                    'border-radius':'0 0.56rem 0.56rem 0'
                }
            }
            const styleResult = Object.assign({}, extra, {
                'background-color':'#C9C9C9',
            })
            return styleResult
        },
        // 表格内容圆角
        setCellStyle({row, column, rowIndex, columnIndex}){
            let extra = {}
            if (columnIndex === 0){
                extra = {
                    'border-radius':'0.56rem 0 0 0.56rem'
                }
            } else if(columnIndex === 4){
                extra = {
                    'border-radius':'0 0.56rem 0.56rem 0'
                }
            }
            const styleResult = Object.assign({}, extra, {
                
            })
            return styleResult
        },
        currentChange(page){
            this.currentElPage = page
            this.getUserFiles()
        },
        handleChangeSize(val){
            this.size = val
            this.getUserFiles()
        },
        prevClick(){
            if(this.currentElPage == 1 ){
                return
            }
            this.currentElPage--
            this.userProjectList = this.userProjectLists.slice((this.currentElPage-1)*10,this.currentElPage*10)
            // this.industrialModel = industrialModels.slice(8, 16)
        },
        nextClick(){
            // 向上取整
            let total = Math.ceil(this.totalProjects/10)
            if(this.currentElPage === total || this.currentElPage > total){
                return
            }
            this.currentElPage++
            this.userProjectList = this.userProjectLists.slice((this.currentElPage-1)*5,this.currentElPage*5)
            // this.industrialModel = industrialModels.slice(0, 8)
        },
        updateProjectList(){
            let obj = {
                account: window.localStorage.getItem("userName"),
                token: window.localStorage.getItem("userToken"),
            }
            getUserProject(obj).then((res)=>{
                if(res.code === '0'){
                    this.userProjectList = res.data.list
                    this.total = Number(res.data.total)
                    // console.log(time.toLocaleString());
                    this.userProjectList.forEach((item) => {
                        let time = new Date(Number(item.createTime))
                        item.createTime = time.toLocaleString()
                    })
                    // this.userProjectList.createTime = time.toLocaleString()
                    console.log(this.userProjectList);
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        shareModel(id){
            let url = `http://pongo.net.cn/share?id=${id}`
            if (navigator.clipboard && window.isSecureContext) {
                // navigator clipboard 向剪贴板写文本
                navigator.clipboard.writeText(url).then(() => {
                    this.$message.success('已复制到剪切板')
                });
            } else {
                // 创建text area
                let textArea = document.createElement("textarea");
                textArea.value = url;
                // 使text area不在viewport，同时设置不可见
                textArea.style.position = "absolute";
                textArea.style.opacity = 0;
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                return new Promise((res, rej) => {
                    // 执行复制命令并移除文本框
                    document.execCommand('copy') ? res() : rej();
                    textArea.remove();
                    this.$message.success('已复制到剪切板')
                });
            }
        },
        deleteModel(id){
            let obj = {
                id,
                token: window.localStorage.getItem("userToken"),
            }
            deleteUserFile(obj).then((res) => {
                if(res.code === '0'){
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    this.updateProjectList()
                }
            })
        },
        getUserFiles(){
            let obj = {
                current: this.currentElPage,
                size: this.size
            }
            let token = window.localStorage.getItem("userToken")
            getUserFile(obj, token).then((res)=>{
                if(res.code === 200){
                    this.userProjectList = res.data.records
                    this.total = res.data.total
                }
                else {
                    this.$message.error(res.message)
                }
            })
        }
    },
    components: {
        ModelShowList
    },
    mounted() {
        this.getUserFiles()
    }
}
</script>

<style scoped lang="less">
::v-deep .el-table td.el-table__cell div{
    display: flex;
    justify-content: center;
}
// ::v-deep .el-table_6_column_30{
//     border-top-left-radius: 0.56rem;
//     border-bottom-left-radius: 0.56rem;
// }
// ::v-deep .el-table_6_column_33{
//     border-top-right-radius: 0.56rem;
//     border-bottom-right-radius: 0.56rem;
// }
// ::v-deep .el-table__body td .cell {
//   padding-top: 2.5rem;
//   padding-bottom: 2.5rem;
// }
// ::v-deep .el-table th.el-table__cell>.cell{
//     font-size: 0.85rem;
//     font-weight: normal;
//     color: #666666;
// }
::v-deep .el-table th.el-table__cell{
    background-color: #C9C9C9;
}
::v-deep .el-table .cell{
    text-align: center;
}
::v-deep .el-table .deep{
    background-color: #F9F9F9;
    border-radius: 10px;
}
::v-deep .el-table .shallow{
    background-color: #f4f4f4;
    border-radius: 10px;

}
::v-deep .el-table__header-wrapper,
::v-deep .el-table__body-wrapper{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 94%;
    margin: 0 auto;
}
::v-deep .el-table__header{
    width: auto !important;
}
::v-deep .el-table__body{
    width: auto !important;
  //-webkit-border-horizontal-spacing: 13px;  // 水平间距
  -webkit-border-vertical-spacing: 6px;  // 垂直间距
}
::v-deep .el-table::before{
    display: none;
}
// ::v-deep .el-table th.el-table__cell{
//     background-color: rgb(173, 173, 173);
// }
// ::v-deep .el-table_1_column_1{
//     border-top-left-radius: 10px;
//     border-bottom-left-radius: 10px;
// }
// ::v-deep .el-table_1_column_4{
//     border-top-right-radius: 10px;
//     border-bottom-right-radius: 10px;
// }
::v-deep .el-table th.el-table__cell>.cell{
    font-size: 0.85rem;
    font-weight: normal;
    color: #666666;
}
.my_model{
    // background-color: rgb(255, 255, 255);
    border-radius: 0.56rem;
    .model_container{
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 2.69rem 0;
        // height: 90px;
        i{
            font-size: 1.5rem;
            cursor: pointer;
        }
        i:hover{
            color: #54d1ef;
        }
        .title{
            background-color: aqua;
            width: 90%;
            height: 100%;
            margin: 0 auto;
        }
        .operate_inner{
            display: flex;
            justify-content: center;
            align-items: center;
            ::v-deep .el-button{
                background-color: #cccccc;
                border-radius: 20px;
                color: #fff;
            }
            ::v-deep .el-button:hover{
                background-color: #54d1ef;
                color: #fff;
            }
            .img_container{
                width: 1.31rem;
                height: 1.31rem;
                padding: 0.8rem;
                background-color: #C9C9C9;
                border-radius: 90%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 0.6rem;
            }
            .img_container:hover{
                cursor: pointer;
                background-color: #54ceec;
            }
            ::v-deep .el-icon-delete-solid{
                color: #C9C9C9;
            }
            ::v-deep .el-icon-delete-solid:hover{
                cursor: pointer;
                color: #54ceec;
            }
        }
    }
    .model_page{
        // margin: 0 auto;
        display: flex;
        justify-content: center;
        padding: 2rem 0;
        // background-color: #54d1ef;
    }
}
</style>